import axios from 'axios'

var util = {};

util.baseApiUrl = '';

util.initBaseUrl = function (rootUrl) {
	this.baseApiUrl = rootUrl + '/api';
}

util.formatDuration = (seconds) => {
	const hours = Math.floor(seconds / 3600);
	const minutes = Math.floor((seconds % 3600) / 60);
	const remainingSeconds = Math.floor(seconds % 60);
	return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
}

util.getCurrentFormattedTime = () => {
	const now = new Date();
	const year = now.getFullYear();
	const month = (now.getMonth() + 1).toString().padStart(2, '0');
	const day = now.getDate().toString().padStart(2, '0');
	const hours = now.getHours().toString().padStart(2, '0');
	const minutes = now.getMinutes().toString().padStart(2, '0');
	const seconds = now.getSeconds().toString().padStart(2, '0');
	return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

util.getPickerTime = (dateArray) => {
	return dateArray.map(dateStr => {
		const date = new Date(dateStr);
		const pad = (n) => (n < 10 ? '0' + n : n);
		const year = date.getFullYear();
		const month = pad(date.getMonth() + 1);
		const day = pad(date.getDate());
		const hours = pad(date.getHours());
		const minutes = pad(date.getMinutes());
		return `${year}-${month}-${day} ${hours}:${minutes}`;
	});
};

util.numberToChinese = (num) => {
	const chineseNumbers = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
	const chineseUnits = ['', '十', '百', '千'];
	if (num === 0) return chineseNumbers[0];
	let result = '';
	let digitCount = 0;
	while (num > 0) {
		const digit = num % 10;
		if (digit !== 0) {
			result = chineseNumbers[digit] + chineseUnits[digitCount] + result;
		} else {
			if (result.charAt(0) !== chineseNumbers[0]) {
				result = chineseNumbers[digit] + result;
			}
		}
		num = Math.floor(num / 10);
		digitCount++;
	}
	if (result.startsWith('一十')) {
		result = result.slice(1);
	}
	return result;
}

const renderMathML = (latex) => {
	return new Promise((resolve, reject) => {
		try {
			MathJax.tex2mmlPromise(latex).then((node) => {
				resolve(node);
			}).catch((err) => {
				console.error('MathJax 转换失败:', err);
				resolve(latex);
			});
		} catch (error) {
			reject(error);
		}
	});
};

util.convertLaTeXToMathML = async (content) => {
	const latexRegex = /\$\$(.*?)\$\$|\$(.*?)\$/g;
	let match;
	let mathml = content;
	while ((match = latexRegex.exec(content)) !== null) {
		const latex = match[1] || match[2];
		await renderMathML(latex).then((res) => {
			let mathmlFormula = res.replace(/\\/g, '');
			mathml = mathml.replace(`\\${match[0]}`, mathmlFormula).replace(/<mtext>&#xA0;<\/mtext>/g,
				'');
		})
	}
	return mathml
};

util.toFixedWithoutRounding = (digit) => {
	let str = String(digit);
	let match = str.match(/^\d+(\.\d{1,2})?/);
	if (!match) return NaN;
	return parseFloat(match[0]);
}

util.preciseAddition = (num1, num2) => {
	let factor = 100;
	let intNum1 = Math.trunc(num1 * factor);
	let intNum2 = Math.trunc(num2 * factor);
	let sumInt = intNum1 + intNum2;
	return sumInt / factor;
};

util.preciseSubtraction = (num1, num2) => {
	let factor = 100;
	let intNum1 = Math.trunc(num1 * factor);
	let intNum2 = Math.trunc(num2 * factor);
	let diffInt = intNum1 - intNum2;
	return diffInt / factor;
};

util.parseTime = (time, pattern) => {
	if (!time) {
		return null
	}
	const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if (typeof time === 'object') {
		date = time
	} else {
		if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
			time = parseInt(time)
		} else if (typeof time === 'string') {
			time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
		}
		if ((typeof time === 'number') && (time.toString().length === 10)) {
			time = time * 1000
		}
		date = new Date(time)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
		let value = formatObj[key]
		if (key === 'a') {
			return ['日', '一', '二', '三', '四', '五', '六'][value]
		}
		if (result.length > 0 && value < 10) {
			value = '0' + value
		}
		return value || 0
	})
	return time_str
}

util.formatToW = (num) => {
	var value;
	if (num >= 10000) {
		value = (Math.trunc(num / 10000 * 10) / 10) + 'W';
	} else {
		value = num
	}
	return value
};

util.debounce = (func, wait, immediate) => {
	let timeout, args, context, timestamp, result
	const later = function () {
		const last = +new Date() - timestamp
		if (last < wait && last > 0) {
			timeout = setTimeout(later, wait - last)
		} else {
			timeout = null
			if (!immediate) {
				result = func.apply(context, args)
				if (!timeout) context = args = null
			}
		}
	}
	return function (...args) {
		context = this
		timestamp = +new Date()
		const callNow = immediate && !timeout
		if (!timeout) timeout = setTimeout(later, wait)
		if (callNow) {
			result = func.apply(context, args)
			context = args = null
		}
		return result
	}
}

/**
 * 流文件下载公共方法（支持GET/POST，自动处理二进制流）
 * @param {string} url - 外部传入的下载接口地址
 * @param {string} fileName - 下载后的文件名（需包含扩展名，如：数据报表.xlsx）
 * @param {Object} [options={}] - 可选配置（请求方法、参数、回调等）
 * @param {string} [options.method='get'] - 请求方法（get/post/put等）
 * @param {Object} [options.data=null] - 请求参数（post/put时传，get时忽略）
 * @param {Object} [options.headers={}] - 请求头（如：{'Authorization': 'token'}）
 * @param {Function} [options.onSuccess=()=>{}] - 下载成功回调
 * @param {Function} [options.onError=(err)=>{}] - 下载失败回调
 */

util.downloadFileStream = (url, fileName, options = {}) => {
	const fullUrl = util.baseApiUrl ? util.baseApiUrl + url : url;
	const defaultOpts = {
		method: 'get',
		data: null,
		headers: {},
		onSuccess: () => { },
		onError: (err) => console.error('文件下载失败：', err),
		complete: () => { }
	};

	const {
		method,
		data,
		headers,
		onSuccess,
		onError,
		complete,
		timeout
	} = {
		...defaultOpts,
		...options
	};

	// axios请求配置
	const axiosConfig = {
		url: fullUrl,
		method: method.toLowerCase(),
		responseType: 'blob',
		headers: {
			...headers,
			'Content-Type': 'application/json',
			'Authorization': 'Bearer ' + localStorage.getItem('token')
		},
		transformResponse: [data => data] // 保留原始响应结构，确保config存在
	};
	if (timeout) {
		axiosConfig.timeout = timeout;
	}

	if (['post', 'put', 'patch'].includes(axiosConfig.method) && data) {
		axiosConfig.data = data;
	}

	// 根据Content-Type获取文件扩展名
	const getFileExtByContentType = (contentType) => {
		const typeMap = {
			'application/zip': 'zip',
			'application/vnd.ms-excel': 'xls',
			'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
			'application/pdf': 'pdf',
			'application/msword': 'doc',
			'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx'
		};
		for (const [type, ext] of Object.entries(typeMap)) {
			if (contentType.includes(type)) return ext;
		}
		return 'bin';
	};

	// 格式化文件名（处理特殊字符+补全扩展名）
	const formatFileName = (name, contentType) => {
		if (!name) return '未命名文件';
		const cleanName = name.replace(/[\\/:*?"<>|]/g, '_'); // 替换特殊字符
		if (cleanName.includes('.')) return cleanName; // 已有扩展名则直接返回
		const ext = getFileExtByContentType(contentType);
		return `${cleanName}.${ext}`; // 补全扩展名
	};

	// 解析Blob错误信息
	const parseErrorBlob = async (blob) => {
		try {
			const text = await new Response(blob).text();
			return JSON.parse(text);
		} catch (e) {
			return await new Response(blob).text();
		}
	};

	// 发送请求
	axios(axiosConfig)
		.then((response) => {
			try {
				const contentType = response.headers['content-type'] || 'application/octet-stream';

				// 优先通过Content-Type判断是否为文件流
				const isFileStream =
					contentType.includes('zip') ||
					contentType.includes('excel') ||
					contentType.includes('pdf') ||
					contentType.includes('word') || ['xlsx', 'xls', 'pdf', 'doc', 'docx', 'zip'].includes(
						fileName.split('.').pop()?.toLowerCase());

				// 处理JSON错误响应（非文件流且为JSON类型）
				if (!isFileStream && contentType.includes('application/json')) {
					parseErrorBlob(response.data).then((errData) => {
						onError({
							message: '接口返回错误信息',
							response,
							config: response.config,
							errData
						});
						complete();
					});
					return;
				}

				// 格式化文件名（补全扩展名）
				const formattedFileName = formatFileName(fileName, contentType);

				// 创建Blob对象
				const blob = new Blob([response.data], {
					type: contentType
				});

				// 生成下载链接
				const downloadUrl = window.URL.createObjectURL(blob);

				// 创建a标签并触发下载
				if (!document.body) throw new Error('页面DOM未就绪');
				const link = document.createElement('a');
				link.href = downloadUrl;
				link.download = formattedFileName;
				link.style.display = 'none';
				document.body.appendChild(link);
				link.click();

				// 延迟清理资源，确保下载完成
				setTimeout(() => {
					document.body.removeChild(link);
					window.URL.revokeObjectURL(downloadUrl);
				}, 200);

				// 成功回调
				onSuccess({
					response,
					fileName: formattedFileName,
					config: response.config
				});
				complete();

			} catch (innerErr) {
				// 捕获下载逻辑内部错误
				onError({
					message: `下载处理失败：${innerErr.message}`,
					response,
					config: response.config || axiosConfig,
					innerError: innerErr
				});
				complete();
			}
		})
		.catch(async (error) => {
			// 捕获axios请求错误
			let errorMsg = error.message || '网络请求异常';
			let errorData = error.response?.data;

			if (error.response?.data instanceof Blob) {
				errorData = await parseErrorBlob(error.response.data).catch(() => error.response.data);
				errorMsg = typeof errorData === 'object' ? errorData.message : errorData;
			}

			onError({
				message: errorMsg,
				response: error.response,
				config: error.config || axiosConfig,
				innerError: error
			});
			complete();
		});
};

export default util;